import { render } from "./ResultsWindow.vue?vue&type=template&id=0193be08&scoped=true"
import script from "./ResultsWindow.vue?vue&type=script&lang=js"
export * from "./ResultsWindow.vue?vue&type=script&lang=js"

import "./ResultsWindow.vue?vue&type=style&index=0&id=0193be08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0193be08"]])

export default __exports__